<div class="layout-topbar" style="background-color: #02640d">
  <a class="layout-topbar-logo" routerLink="">
    <span class="text-white">Martin BBQ Admin Portal</span>
  </a>

  <button
    #menubutton
    class="p-link layout-menu-button layout-topbar-button text-white"
    (click)="layoutService.onMenuToggle()"
  >
    <i class="pi pi-bars"></i>
  </button>

  <button
    #topbarmenubutton
    class="p-link layout-topbar-menu-button layout-topbar-button text-white"
    (click)="layoutService.showProfileSidebar()"
  >
    <i class="pi pi-ellipsis-v"></i>
  </button>

  <div
    #topbarmenu
    class="layout-topbar-menu text-white"
    [ngClass]="{ 'layout-topbar-menu-mobile-active': layoutService.state.profileSidebarVisible }"
  >
    <button class="p-link layout-topbar-button text-white">
      <i class="pi pi-user"></i>
      <span>Profile</span>
    </button>
  </div>
</div>
